export enum ScreenSize {
  XSMALL = 1,
  SMALL = 2,
  MEDIUM = 3,
  LARGE = 4,
  XLARGE = 5,
  XXLARGE = 6
}
